<template>
	<div class="navigation">
		<NavDesktop class="desktop"></NavDesktop>
		<NavMobile class="mobile"></NavMobile>
	</div>
</template>

<script>
import NavDesktop from '@/components/navigation_desktop'
import NavMobile from '@/components/navigation_mobile'
export default {
  name: "navigation",
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    NavDesktop,
    NavMobile
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../stylesheet/base.sass'
  @import '../stylesheet/layout.sass'
  .navigation
    .mobile
      display: none
    .desktop
      display: flex
    @media screen and (max-width: 990px)
      .mobile
        display: flex
      .desktop
        display: none

</style>



// WEBPACK FOOTER //
// src/components/navigation.vue